import { useApi } from '../api/useApi';
import Loader from './ui/Loader';
import SectionHeader from './ui/SectionHeader';
import { mediaUrl } from '../api/client';

export default function About() {
  const { data: settings, loading } = useApi('/settings', 'settings');
  const about = settings?.about;

  if (loading) {
    return (
      <section className="section section--about" id="about">
        <Loader />
      </section>
    );
  }

  return (
    <section className="section section--about" id="about">
      <div className="container about">
        <div className="about__content">
          <SectionHeader
            eyebrow="Nosotros"
            title={about?.heading}
            subtitle={about?.subheading}
            align="left"
          />
          <div className="about__stats">
            <div className="about__stat">
              <span className="about__stat-value">10+</span>
              <span className="about__stat-label">Años de experiencia</span>
            </div>
            <div className="about__stat">
              <span className="about__stat-value">500+</span>
              <span className="about__stat-label">Casos atendidos</span>
            </div>
            <div className="about__stat">
              <span className="about__stat-value">100%</span>
              <span className="about__stat-label">Compromiso ético</span>
            </div>
          </div>
        </div>
        <div className="about__visual">
          <div className="about__frame">
            <img
              src={mediaUrl(about?.image_url || '/assets/images/about_bg.jpg')}
              alt=""
              loading="lazy"
            />
          </div>
          <div className="about__accent" aria-hidden="true" />
        </div>
      </div>
    </section>
  );
}
